import { API_BASE_URL } from '@/config/env';

export type OutletSearchRow = {
  uuid: string;
  outlet_name: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  postcode: string | null;
};

/**
 * Search outlets by address substring (backend: case-insensitive contains).
 */
export async function fetchOutletsByAddressQuery(
  q: string,
  signal?: AbortSignal
): Promise<OutletSearchRow[]> {
  const trimmed = q.trim();
  if (trimmed.length < 1) {
    return [];
  }

  const params = new URLSearchParams({ q: trimmed });
  let res: Response;
  try {
    res = await fetch(`${API_BASE_URL}/api/v1/outlets/search?${params.toString()}`, {
      signal,
    });
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') {
      return [];
    }
    throw e;
  }

  const data = (await res.json()) as { outlets?: unknown; error?: string };

  if (!res.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : 'Search failed');
  }
  if (!Array.isArray(data.outlets)) {
    return [];
  }

  return data.outlets.filter(
    (row): row is OutletSearchRow =>
      typeof row === 'object' &&
      row !== null &&
      typeof (row as OutletSearchRow).uuid === 'string' &&
      (row as OutletSearchRow).uuid.length > 0
  );
}
